import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const behaviourState = atom<boolean>({
  key: 'behaviourState',
  default: true,
  effects_UNSTABLE: [persistAtom],
});
